import {FormPromptWrapper, LabelForm} from "./FormPrompt.styled";
import TextInput from "../../../../../elements/v2/TextInput/TextInput";
import SelectDropdown from "../../../../../elements/v2/SelectDropdown/SelectDropdown";
import TextArea from "../../../../../elements/v2/TextArea/TextArea";
import {observer} from "mobx-react";
import {usePromptManagementStore} from "../../hooks";
import {Loading} from "../../../../../components";

export const FormPrompt = observer(() => {
  const { currentPrompt, categories, agents, selectedAgent, onChangeSelectedAgent } = usePromptManagementStore();

  if (!currentPrompt) {
    return <Loading />;
  } 
  
  return (
    <FormPromptWrapper>
      <LabelForm>Prompt Name</LabelForm>
      <TextInput
        type="text"
        value={currentPrompt.name}
        onChange={(e) => currentPrompt.onChangeField("name",  e.target.value)}
        placeholder="Give your prompt a clear and descriptive name"
        width={"100%"}
        margin={"0px"}
      />
      <LabelForm>Agent</LabelForm>
      <SelectDropdown
        dataTestId="agent-dropdown"
        width={"100%"}
        defaultValue={selectedAgent.value}
        onSelect={(data) => onChangeSelectedAgent(data)}
        items={agents.map((agent) => ({ label: agent.name, value: agent.id }))}
      />
      <LabelForm>Category</LabelForm>
      <SelectDropdown
        dataTestId="category-dropdown"
        width={"100%"}
        defaultValue={currentPrompt.category}
        onSelect={(data) => currentPrompt.onChangeField("category", data.value)}
        items={categories.map((cat) => ({ label: cat, value: cat }))}
      />
      <LabelForm>Short description</LabelForm>
      <TextArea
        type="text"
        value={currentPrompt.shortDescription}
        placeholder="Briefly describe what this prompt does"
        onChange={(e) => currentPrompt.onChangeField("shortDescription", e.target.value)}
        width={"100%"}
        height="80px"
      />
      <LabelForm>Prompt content</LabelForm>
      <TextArea
        type="text"
        value={currentPrompt.promptContent}
        placeholder="Provide detailed instructions to guide how this prompt should work"
        onChange={(e) => currentPrompt.onChangeField("promptContent", e.target.value)}
        width={"100%"}
        height="360px"
      />
      {currentPrompt.updatedAt 
        && 
        <>
          <LabelForm>Last update</LabelForm>
          <TextInput
            type="text"
            disabled={true}
            value={currentPrompt.updatedAt}
            width={"100%"}
            margin={"0px"}
          />   
        </>
      }
    </FormPromptWrapper>
  );
});
